import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./context/AuthContext";
import ScrollToTop from "./components/ScrollToTop";
import MobileCTA from "./components/layout/MobileCTA";

// Pages
import HomePage from "./pages/HomePage";
import UnternehmensbewertungPage from "./pages/UnternehmensbewertungPage";
import UnternehmenVerkaufenPage from "./pages/UnternehmenVerkaufenPage";
import UnternehmenKaufenPage from "./pages/UnternehmenKaufenPage";
import MABeratungPage from "./pages/MABeratungPage";
import BlogPage from "./pages/BlogPage";
import BlogArticlePage from "./pages/BlogArticlePage";
import BlogAdminPage from "./pages/BlogAdminPage";
import KontaktPage from "./pages/KontaktPage";
import BewertungPage from "./pages/BewertungPage";
import AdminDashboardPage from "./pages/AdminDashboardPage";
import LoginPage from "./pages/LoginPage";
import ImpressumPage from "./pages/ImpressumPage";
import DatenschutzPage from "./pages/DatenschutzPage";
import AGBPage from "./pages/AGBPage";
import UeberUnsPage from "./pages/UeberUnsPage";
import ReferenzenPage from "./pages/ReferenzenPage";
import NotFoundPage from "./pages/NotFoundPage";

function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <div className="App">
          <BrowserRouter>
            <ScrollToTop />
            <Routes>
              {/* Main pages */}
              <Route path="/" element={<HomePage />} />
              <Route path="/unternehmensbewertung" element={<UnternehmensbewertungPage />} />
              {/* Legacy URL Redirects (client-side fallback, SSG handles server-side) */}
              <Route path="/firma-bewerten" element={<Navigate to="/unternehmensbewertung" replace />} />
              <Route path="/bewertungsmethoden" element={<Navigate to="/unternehmensbewertung" replace />} />
              <Route path="/über-uns" element={<Navigate to="/ueber-uns" replace />} />
              {/* Blog Consolidation Redirect: EBIT 2026 -> 2025 (PENDING - activate after CMS merge) */}
              {/* <Route path="/blog/ebitmultiples-schweiz-2026-tabelle-fuer-kmu" element={<Navigate to="/blog/ebitmultiples-schweiz-2025-branchenvergleich" replace />} /> */}
              <Route path="/unternehmen-verkaufen" element={<UnternehmenVerkaufenPage />} />
              <Route path="/unternehmen-kaufen" element={<UnternehmenKaufenPage />} />
              <Route path="/ma-beratung" element={<MABeratungPage />} />
              <Route path="/blog" element={<BlogPage />} />
              <Route path="/blog/admin" element={<BlogAdminPage />} />
              <Route path="/blog/:slug" element={<BlogArticlePage />} />
              <Route path="/kontakt" element={<KontaktPage />} />
              <Route path="/bewertung" element={<BewertungPage />} />
              <Route path="/admin" element={<AdminDashboardPage />} />
              <Route path="/login" element={<LoginPage />} />
              
              {/* About us */}
              <Route path="/ueber-uns" element={<UeberUnsPage />} />
              <Route path="/referenzen" element={<ReferenzenPage />} />
              
              {/* Legal pages */}
              <Route path="/impressum" element={<ImpressumPage />} />
              <Route path="/datenschutz" element={<DatenschutzPage />} />
              <Route path="/agb" element={<AGBPage />} />
              
              {/* 404 */}
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
            <MobileCTA />
          </BrowserRouter>
          <Toaster position="bottom-right" />
        </div>
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;
